import { graphql } from '@/gql/graphql';
export const TeamSelectItemFragment = graphql(/* GraphQL */ `
  fragment TeamSelectItem on team {
    id
    title
    home_primary_color
    avatar_id
  }
`);
